var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slider",
    clipPath: "url(#clip0_626_14166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.848356 0.777553L5.03235 0.777344C5.10756 0.77734 5.17699 0.817713 5.21419 0.883086C5.25138 0.948459 5.25062 1.02877 5.2122 1.09342L3.05702 4.71969C3.01356 4.79281 2.93015 4.83234 2.84604 4.81968C2.76192 4.80701 2.69385 4.74468 2.67385 4.662L2.16912 2.5757L0.701853 1.13608C0.641199 1.07657 0.622568 0.98628 0.654711 0.90762C0.686853 0.82896 0.763382 0.777557 0.848356 0.777553ZM2.59918 2.57403L2.95975 4.06442L4.45755 1.54424L2.59918 2.57403ZM4.22315 1.19578L1.36026 1.19593L2.39348 2.20968L4.22315 1.19578Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_14166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.02079,
    height: 5.02079,
    fill: "white",
    transform: "translate(0.430176 0.358887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d9c0494eafe6e9fe630a5312c5d96164.svg";
export { ForwardRef as ReactComponent };